import { authStore } from "app";
import { inject, observer } from "mobx-react";
import React, { ReactNode } from "react";
import ReactDOM from "react-dom";
import { PageBody } from "components";
import { Loading } from "views";
import { RoutingStore } from "stores";


export interface IPageProps {
  children?:     ReactNode | undefined,
  sidebar?:      ReactNode | undefined,
  topbar?:       ReactNode | undefined,
  routingStore?: RoutingStore | undefined,
  isLoading?:    boolean,
}
export const Page = inject('routingStore')(observer((props: IPageProps): JSX.Element | null => {
  const { isLoading, children, sidebar, topbar, routingStore } = props;

  return (
    <>
      {routingStore.sidebarContainer
        ? ReactDOM.createPortal(sidebar, routingStore.sidebarContainer)
        : null}
      {routingStore.topbarContainer
        ? ReactDOM.createPortal(topbar, routingStore.topbarContainer)
        : null}
      <PageBody>
        {isLoading ? <Loading /> : children}
      </PageBody>
    </>
  );
}));